// extracted by mini-css-extract-plugin
export default {"wrapper":"lx-z","addressLine":"mx-z","fullName":"nx-z"};